<button
  mat-icon-button
  class="tw-absolute tw-top-1 tw-right-1 tw-text-dark-light-dynamic hover:tw-bg-gray-200 dark:hover:tw-bg-gray-700 tw-transition-all"
  (click)="closeDialog()">
  <mat-icon>close</mat-icon>
</button>
<app-billing-products-moneyball
  *ngIf="data.subscriptionType === 'moneyball'"></app-billing-products-moneyball>
<app-billing-products-people
  *ngIf="data.subscriptionType === 'people'"></app-billing-products-people>
<app-billing-products-chat
  *ngIf="data.subscriptionType === 'chat'"></app-billing-products-chat>
